#import "@/components/common/StoryPreviewFragment.gql"
#import "@/components/common/LinkFragment.gql"

fragment SmallStoryFeaturesWithBarsFragment on smallStoryFeaturesWithBars_Entry {
  typeHandle
  heading
  cta {
    ...LinkFragment
  }
  imageTitleFeatures: smallFeaturedStory {
    ... on storiesFeaturedStoryBlock_Entry {
      id
      heading
      image {
        url
        title
      }
      alt
      page: cta {
        ...LinkFragment
      }
      story {
        uri
        ...StoryPreviewFragment
      }
    }
  }
}
